import { useDispatch } from "react-redux";
import { setAuth } from "../store/features/authSlice";
import axios from "../apis/axios";

const useRefreshToken = () => {
	const dispatch = useDispatch();

	const refresh = async (refreshToken) => {
		const response = await axios.post("/gs1/standard/refresh", refreshToken, {
			withCredentials: true,
		});
		dispatch(
			setAuth({
				accessToken: response.data?.data?.tokens?.accessToken,
				user: response.data?.data?.user,
				providerToken: response.data?.data?.providerToken,
				login: true,
			})
		);
		return response?.data?.accessToken;
	};
	return refresh;
};

export default useRefreshToken;
